import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { TWarehousePerformanceSeriesRes } from 'api/swagger';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data';
import type { IWhPerformanceListProps } from './types';
import styles from './wh-performance-list.module.scss';

export const WhPerformanceList: React.FC<IWhPerformanceListProps> = (props) => {
  const { data, isLoading } = props;

  const dataWithIds = data.map((item, index) => ({ ...item, id: index }));
  const tableData = useTransformToTableData(dataWithIds);

  const columns: ColumnsType<TWarehousePerformanceSeriesRes> = [
    {
      title: 'Warehouse',
      dataIndex: 'name',
      key: 'name',
      width: '40%',
    },
    {
      title: 'LDM',
      dataIndex: 'ldm',
      key: 'ldm',
      align: 'right',
      width: '30%',
      render: (value: number) => value.toFixed(2),
    },
    {
      title: 'Load (%)',
      dataIndex: 'load',
      key: 'load',
      align: 'right',
      width: '30%',
      render: (value: number) => value.toFixed(2),
    },
  ];

  return (
    <Table
      className={styles.table}
      columns={columns}
      dataSource={tableData}
      pagination={false}
      loading={isLoading ? { size: 'large', delay: 200 } : false}
      size='small'
      bordered
    />
  );
};
